/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShare3 = createReactComponent("outline", "share-3", "IconShare3", [["path", { "d": "M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7z", "key": "svg-0" }]]);

export { IconShare3 as default };
//# sourceMappingURL=IconShare3.mjs.map
